<template>
    <div class="SideMenu" :class="{ menuActive: isActive }">
        <div @click="menuToggler" class="overlay_container"></div>
        <SideMenuLinks :menuToggler="menuToggler" :isActive="isActive" />
    </div>
</template>

<script>
import SideMenuLinks from '@/components/MobileMenu/SideMenuLinks'

export default {
    name: 'SideMenu',
    components: {
        SideMenuLinks
    },
    props: {
        isActive: {
            type: Boolean,
            required: true
        },
        menuToggler: Function
    }
}

</script>

<style lang="scss" scoped>

.SideMenu {
    position: fixed;
    height: 100%;
    width: 100%;
    top: 80px;
    bottom: 0;
    left: 0;
    right: 0;
    transition: 0.3s;
    opacity: 0;
    visibility: hidden;
}

.overlay_container {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.3);
}

.menuActive {
    right: 0;
    transition: 0.3s;
    opacity: 1;
    visibility: visible;
}
</style>
